import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Col, Container, Row } from "react-bootstrap";
import "./styles.scss";
import QuestionsSteps from "./QuestionsSteps/QuestionsSteps";
import logo from "../../assets/logo.png";
import bgImg from "../../assets/onboardingBg.png";
import Sidebar from "./../Sidebar";
import Mode from "../Mode";

const theme = createTheme({
  palette: {
    primary: {
      main: "#48B7A7",
    },
    background: {
      paper: "#E8F9FD",
    },
  },
});

const Questions = () => {
  return (
    <>
    <ThemeProvider theme={theme}>
      <Container fluid>
        <Row>
          <Sidebar isTutorial />
          <Col>
            {/*<div className="nodata-header">*/}
            {/*  <nav className="overview-navbar w-100 bg-white">*/}
            {/*    <img alt="logo" className="logo" src={logo} />*/}
            {/*    <div className="d-flex justify-align-content-center">*/}
            {/*      <p className="user-information">User's</p>*/}
            {/*      <div className="profile-icon">U</div>*/}
            {/*    </div>*/}
            {/*  </nav>*/}
            {/*</div>*/}
            <QuestionsSteps />
          </Col>
        </Row>
      </Container>
    </ThemeProvider>
    <Mode/>
    </>
  );
};
export default Questions;
